import {useStore} from '@xyflow/react';

/**
 * Hook that subscribes ONLY to zoom changes, not pan (x/y) position changes.
 * This prevents components from rerendering during panning operations.
 *
 * React Flow's viewport consists of {x, y, zoom}.
 * Using useViewport() subscribes to all three values.
 * This hook uses a selector to subscribe only to zoom.
 */
export const useZoomOnly = (): number => {
  // React Flow stores viewport as transform: [x, y, zoom]
  // By selecting only the zoom value, we avoid rerenders on x/y changes
  const zoom = useStore((state) => state.transform[2]);

  return zoom;
};
